const fonts = {
  freight: 'Freight',
  inter: 'Inter',
};

export default fonts;
